var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rco-single-card-selector-button"},[_c('vue-button',{attrs:{"id":_vm.buttonId,"aria-labelledby":_vm.buttonLabelledBy,"disabled":_vm.sending},on:{"click":_vm.getCookie}},[_vm._t("default")],2),(_vm.technicalError)?_c('vue-error-message',[_vm._v("Technikai hiba történt, kérjük próbálja újra később!")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }